import * as React from 'react';
import { translate } from 'react-i18next';
import { IShopListItem } from 'models/shop/shoplistitem';
import * as c from 'models/constants';
import { CardItemProfileInfo } from 'components';
import { IItemCardProps } from 'models/itemcard';
import { IAuthContext } from 'models/common';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { formatInteger, imgSrcAttributes } from 'helpers/common';
import { FollowButton } from 'components/Common/FollowButton';
require('./style.css');
interface IProps extends IItemCardProps {
	item: IShopListItem;
	t?: (key: string, options?: any) => string;
	context?: IAuthContext;
	isFollowing?: boolean;
	followItem?: () => void;
	unfollowItem?: () => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopItemCardComponent extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onViewStoreClick = this.onViewStoreClick.bind(this);
	}

	private onViewStoreClick(e: React.SyntheticEvent) {
		e.preventDefault();
		if (this.props.goToCard) {
			this.props.goToCard(this.props.item.entityId);
		}
	}

	public render() {
		const { t, item, followItem, isFollowing, unfollowItem } = this.props;

		let shopPictureToDisplay = require('containers/Html/images/defaultShop.svg');
		let withPicture = false;
		if (item.picture && item.picture.length) {
			shopPictureToDisplay = item.picture;
			withPicture = true;
		}
		if (item.coverPicture && item.coverPicture.length) {
			shopPictureToDisplay = item.coverPicture;
			withPicture = true;
		}

		return (
			<div className="shopItemCard">
				<div
					className="portalPageShopItemImage"
					onClick={(e) => this.onViewStoreClick(e)}
					style={withPicture ? { backgroundImage: 'url("' + shopPictureToDisplay + '")' } : undefined}
				>
					<img
						className={'shopPicture' + (withPicture ? ' withPicture' : '')}
						{...imgSrcAttributes(shopPictureToDisplay)}
						alt=""
					/>
					<FollowButton follow={followItem} unfollow={unfollowItem} isFollowing={isFollowing} fullWidth={true} />
				</div>
				<CardItemProfileInfo
					name={item.name}
					followersCount={formatInteger(item.followersCount)}
					followersText={t('BSPortal_Common_Followers')}
					description={item.description}
					location={item.location}
					onClick={(e) => this.onViewStoreClick(e)}
				/>
			</div>
		);
	}
}
const ShopItemCard = withAuthContext(ShopItemCardComponent);
export { ShopItemCard };
